// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__1xidV","balanceDisclaimer":"posDashboard_balanceDisclaimer__vOe_4"};